export default {
  UNC: 1, // Ủy nhiệm chi
  GNT: 2, // Giấy nhận tiền
};
